import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '@app/core/services/auth.service';
import { DataService } from '@app/core/services/data.service';
import { OidcSecurityService } from 'angular-auth-oidc-client';

@Component({
    selector: 'app-callback',
    templateUrl: './callback.component.html',
    styleUrls: ['./callback.component.scss'],
    standalone: true
})
export class CallbackComponent implements OnInit {

  constructor(public oidcSecurityService: OidcSecurityService,private dataService: DataService, private authService:AuthService, private router:Router) { }

  ngOnInit(): void {
  
    this.oidcSecurityService.checkAuth().subscribe(({isAuthenticated, userData, accessToken, idToken, errorMessage})=>{
      console.log("is Authenticated", isAuthenticated);
      if(isAuthenticated){
        this.authService.checkLogin(true)
          this.dataService.current_business_request = this.dataService.instantiateRequest();
          // this.router.navigate(['/agent']);
        
       
      }
      
    })
  }

}
